import React from 'react';
import ModalWindow from "../ModalWindow/ModalWindow";
import ObjectData from "../../dataModel/ObjectData";
import './ConnectedObjectList.css';


export default class ConnectedObjectList extends React.Component {

    static instance;

    state = {
        isModalOpened: false
    };

    openModal = () => {
        this.setState({
            isModalOpened: true
        });
    };

    closeModal = () => {
        this.setState({
            isModalOpened: false
        });
    };

    componentDidMount() {
        console.log('Mounted');
        ConnectedObjectList.instance = this;
    }

    renderParent = () => {
        const {object} = this.props;

        if (object.parentObject) {
            const item = new ObjectData(object.parentObject);

            return (
                <a className='RelatedListLink' href={"/play/?" + item.objectId}>
                    <div className='RelatedListItem'>
                        <i className="fas fa-arrow-left"/> {item.getDescription}
                    </div>
                </a>
            )
        }

        return null;
    };

    renderAuthor = () => {

    };

    renderChildren = () => {
        const {object} = this.props;

        if (object.childrenList) {
            return object.childrenList.map(child => {
                const item = new ObjectData(child);

                return (
                    <a className='RelatedListLink' href={"/play/?" + item.objectId}>
                        <div className='RelatedListItem'
                             key={'child_' + item.objectId}>
                            <i className="fas fa-arrow-right"/> {item.getDescription}
                        </div>
                    </a>
                )
            });
        }

        return null;
    };

    renderNoRelations = () => {
        const {object} = this.props;

        if (!object.parentObject && !object.childrenList) {
            return (
                <p>
                    Doesn't have related objects
                </p>
            )
        }

        return null;
    };

    render() {
        const {object} = this.props;
        if (!this.state.isModalOpened) return null;
        if (!object) return null;

        return (
            <ModalWindow close={this.closeModal}>
                <div className="modalContainer centered">
                    <this.renderParent />
                    <this.renderAuthor />
                    <this.renderChildren />

                    <this.renderNoRelations />
                </div>
            </ModalWindow>
        );
    }

}
